import { RouteObject } from "react-router-dom";

const LEAGUE_SHADOWED_GLOBAL_SEGMENTS = new Set(["teams", "audit-logs/:tabId?"]);

/**
 * Remove global pages that would shadow dedicated league pages, at every depth
 * of the route tree. No entity-detail subtree owns a route named after one of
 * the shadowed segments, so the filter needs no carve-out.
 */
export const stripLeagueShadowedSegments = (routes: RouteObject[]): RouteObject[] =>
  routes
    .filter(
      (route) =>
        !(typeof route.path === "string" && LEAGUE_SHADOWED_GLOBAL_SEGMENTS.has(route.path))
    )
    .map((route) =>
      route.children
        ? ({ ...route, children: stripLeagueShadowedSegments(route.children) } as RouteObject)
        : route
    );
